import { RatingTaxonomy } from './rating_taxonomy.js';

/**
 * Location types information.
 */
const LocationTypeInfoData = {
  // accommodation
  accommodation: {
    name: 'Accomodation',
    zoom: 14,
    icon_url: '/images/map-cabin.png',
    mapicon_url: '/images/map-cabin-simple.png',
    attributes: {
      amenities: ['water', 'electricity', 'playground', 'bbq'],
    },
    rels: ['toponym'],
    subtypes: ['Lodge', 'Cabin', 'Yurt'],
  },

  // campground
  campground: {
    name: 'Campground',
    zoom: 10,
    icon_url: '/images/map-camping.png',
    mapicon_url: '/images/map-camping.png',
    attributes: {
      amenities: ['water', 'electricity', 'playground', 'bbq'],
    },
    rels: ['toponym'],
    subtypes: [],
  },

  // campsite
  campsite: {
    name: 'Campsite',
    zoom: 15,
    icon_url: '/images/map-campfire.png',
    mapicon_url: '/images/map-campfire.png',
    attributes: {
      features: [
        'beach',
        'boat access',
        'dock',
        'great view',
        'good swimming',
        'island',
        'jumping rock',
        'large',
        'rock outcrop',
        'rugged',
        'treed',
        'open',
        'sandy beach',
        'sandy bottom shore',
        'shady',
        'small',
        'sunset',
        'sunny',
        'weedy',
        'windy',

        'grill',
        'fireplace',
        'fire ring',
        'food locker',
        'kitchen table',
        'privy',
        'picnic table',
        'seating bench',

        'blueberries',
        'cider',
        'grassy',
        'juniper',
        'maples',
        'mature pines',
        'mixed forest',
        'oaks',
        'raspberries',
        'strawberries',
        'pines',
        'poison ivy',
      ],
    },
    rels: ['toponym', 'waterbody'],
    subtypes: [
      'Car campsite',
      'Electical campsite',
      'Emergency campsite',
      'Waterside campsite',
      'Waterside campsite (group)',
      'Waterside campsite (reservable)',
      'Group campsite',
      'Hiking campsite',
      'Jump off campsite',
      'RV campsite',
      'Walk-in campsite',
    ],
    ratings: [
      RatingTaxonomy.FeatureGroup([
        RatingTaxonomy.Size,
        RatingTaxonomy.View,
        RatingTaxonomy.Privacy,
        RatingTaxonomy.Cleanliness,
        RatingTaxonomy.Novelty,
        RatingTaxonomy.Wateraccess,
        RatingTaxonomy.Swimming,
        RatingTaxonomy.Firewood,
      ]),
      RatingTaxonomy.SleepingGroup(),
      RatingTaxonomy.VexerGroup(),
      RatingTaxonomy.NeighbourGroup(),
      RatingTaxonomy.EncounterGroup(),
    ],
  },

  // day use area
  dayuse: {
    name: 'Day Use Area',
    zoom: 12,
    icon_url: '/images/map-picnic.png',
    mapicon_url: '/images/map-picnic-simple.png',
    attributes: {
      amenities: ['picnic table', 'bbq'],
    },
    rels: ['toponym', 'waterbody'],
    subtypes: [],
  },

  // gate
  gate: {
    name: 'Registration',
    zoom: 9,
    icon_url: '/images/map-reception.png',
    mapicon_url: '/images/map-reception.png',
    attributes: {
      amenities: ['store', 'washroom', 'permits', 'parking', 'first aid'],
    },
    rels: ['toponym'],
    subtypes: ['Gate', 'Office'],
  },

  // landform
  landform: {
    name: 'Landform',
    zoom: 12,
    icon_url: '/images/map-forest.png',
    mapicon_url: '/images/map-forest-simple.png',
    subtypes: {
      // beach
      beach: {
        name: 'Beach',
        icon_url: '/images/map-beach.png',
        mapicon_url: '/images/map-beach-simple.png',
        attributes: {
          features: ['sandy', 'gravel'],
        },
      },
      // canyon
      canyon: {
        name: 'Canyon',
        icon_url: '/images/map-canyon.png',
        mapicon_url: '/images/map-canyon-simple.png',
        attributes: {
          features: [],
        },
      },
      // island
      island: {
        name: 'Island',
        attributes: {
          features: ['small', 'large'],
        },
      },
      // peak
      peak: {
        name: 'Peak',
        icon_url: '/images/map-peak.png',
        mapicon_url: '/images/map-peak-simple.png',
        attributes: {
          features: ['easy', 'challenging'],
        },
        rels: ['toponym'],
      },
      // peninsula
      peninsula: {
        name: 'Peninsula',
        attributes: {
          features: [],
        },
      },
      // point
      point: {
        name: 'Point',
        attributes: {
          features: [],
        },
      },
    },
    rels: ['toponym', 'waterbody'],
  },

  landing: {
    name: 'Landing',
    zoom: 15,
    subtypes: {
      portagelanding: {
        name: 'Portage Landing',
        zoom: 12,
        icon_url: '/images/map-portage.svg',
        mapicon_url: '/images/map-portage.png',
      },
    },
    rels: ['waterbody'],
  },

  // outfitter
  outfitter: {
    name: 'Outfitter',
    zoom: 9,
    icon_url: '/images/map-kayak.png',
    mapicon_url: '/images/map-kayak.png',
    attributes: {
      services: [
        'canoe rentals',
        'kayak rentals',
        'paddleboard rentals',
        'equipment rentals',
        'outfitting packages',
        'canoe delivery',
        'shuttle services',
      ],
    },
    subtypes: [],
  },

  // parking
  parking: {
    name: 'Parking',
    zoom: 15,
    icon_url: '/images/map-parking.png',
    mapicon_url: '/images/map-parking.png',
    attributes: {
      features: ['tiny', 'small', 'medium', 'large'],
    },
    rels: ['trailhead', 'wateraccess'],
    subtypes: [],
  },

  // poi
  poi: {
    name: '',
    zoom: 0,
    icon_url: '/images/map-info.png',
    mapicon_url: '/images/map-info.png',
    keywords: [],
    keywords_label: 'Features',
  },

  // portage
  portage: {
    name: 'Portage',
    zoom: 12,
    icon_url: '/images/map-portage.svg',
    mapicon_url: '/images/map-portage.png',
    attributes: {
      features: [
        'flat',
        'steep',
        'tough',
        'easy',
        'muddy',
        'long',
        'busy',
        'overgrown',
        'picturesque',
      ],
    },
    rels: [
      {
        type: 'toponym',
        relType: 'one-to-one',
      },
      {
        type: 'landing',
        relType: 'one-to-many',
      },
    ],
    subtypes: [],
    canHaveRoute: true,
  },

  // sight
  sight: {
    name: 'Sight',
    zoom: 14,
    icon_url: '/images/map-sight.png',
    mapicon_url: '/images/map-sight-simple.png',
    attributes: {
      features: [],
    },
    subtypes: {
      cave: {
        name: 'Cave',
        icon_url: '/images/map-cave.png',
        mapicon_url: '/images/map-cave-simple.png',
      },
      jumpingrock: {
        name: 'Jumping rock',
        icon_url: '/images/map-diving.png',
        mapicon_url: '/images/map-diving-simple.png',
      },
      petroglyphs: {
        name: 'Petroglyphs',
        icon_url: '/images/map-petroglyphs.png',
        mapicon_url: '/images/map-petroglyphs-simple.png',
      },
      pictographs: {
        name: 'Pictographs',
        icon_url: '/images/map-petroglyphs.png',
        mapicon_url: '/images/map-petroglyphs-simple.png',
      },
      rock: {
        name: 'Rock',
        icon_url: '/images/map-cave.png',
        mapicon_url: '/images/map-cave-simple.png',
      },
      ruins: {
        name: 'Ruins',
        icon_url: '/images/map-ruins.png',
        mapicon_url: '/images/map-ruins-simple.png',
      },
      viewpoint: {
        name: 'View Point',
        icon_url: '/images/map-panoramicview.png',
        mapicon_url: '/images/map-panoramicview-simple.png',
      },
    },
  },

  // summercamp
  summercamp: {
    name: 'Summercamp',
    zoom: 9,
    icon_url: '/images/map-summercamp.png',
    mapicon_url: '/images/map-summercamp.png',
    attributes: {
      activities: [
        'backcountry trips',
        'outdoor camping',
        'canoeing',
        'mountain biking',
        'swimming',
        'arts and crafts',
        'hiking',
      ],
    },
    subtypes: [],
  },

  // toponym
  toponym: {
    name: 'Toponym',
    zoom: 0,
    icon_url: '/images/map-flag.png',
    mapicon: {
      url: '/images/map-flag-simple.png',
      size: { width: 24, height: 27 },
      anchor: { x: 6, y: 27 },
    },
    attributes: {
      activities: [
        'backcountry camping',
        'backpacking',
        'biking',
        'birding',
        'boating',
        'canoeing',
        'car camping',
        'cycling',
        'crosscountry skiing',
        'day use',
        'disc golf',
        'dog free camping',
        'dogsledding',
        'downhill skiing',
        'golf',
        'group camping',
        'fishing',
        'hiking',
        'horseback riding',
        'hunting',
        'ice fishing',
        'kayaking',
        'kite boarding',
        'mountain biking',
        'picnicking',
        'radio free camping',
        'rock climbing',
        'RVing',
        'snowmobiling',
        'snowshoeing',
        'skating',
        'swimming',
        'tobogganing',
        'walk-in camping',
        'whitewater paddling',
        'winter camping',
      ],
      facilities: [
        'all terrain wheelchairs',
        'amphitheatres',
        'art galleries',
        'bike rentals',
        'boat launches',
        'cabins',
        'canoe rentals',
        'car camping campsites',
        'comfort stations',
        'docks',
        'dog beaches',
        'dog free campsites',
        'electrical campsites',
        'fish cleaning buildings',
        'food concessions',
        'historic buildings',
        "group BBQ's",
        'group campsites',
        'laundromat',
        'museums',
        'kayak rentals',
        'paddleboat rentals',
        'pet exercise areas',
        'picnic shelters',
        'playgrounds',
        'pools',
        'radio free campsites',
        'roofed accommodation',
        'RV pullthrough campsites',
        'seasonal campsites',
        'showers',
        'SUP rentals',
        'toilets',
        'trailer dump',
        'visitor centre',
        'warm up shelters',
        'wifi',
      ],
    },
    subtypes: [
      'Park',
      'Provincial Park',
      'National Park',
      'Conservation Area',
      'Wilderness Area',
      'Wildlife Reserve',
    ],
  },

  // trailhead
  trailhead: {
    name: 'Trailhead',
    zoom: 10,
    icon_url: '/images/map-hiking.png',
    mapicon_url: '/images/map-hiking.png',
    attributes: {
      activities: [
        'day hike',
        'crosscountry skiing',
        'snowshoeing',
        'backcountry camping',
        'bird watching',
        'bird feeding',
      ],
      difficulty: ['easy', 'moderate', 'advanced', 'difficult'],
      facilities: ['parking', 'picnic areas', 'washroom', 'shelter'],
      features: [
        'rugged',
        'paved',
        'groomed',
        'scentic',
        'historic',
        'natural',
        'urban',
        'wheelchair accessible',
      ],
    },
    rels: ['toponym'],
    subtypes: [],
  },

  // waterbody
  waterbody: {
    name: 'Waterbody',
    zoom: 10,
    icon_url: '/images/map-lake.png',
    mapicon_url: '/images/map-lake-simple.png',
    attributes: {
      features: [
        'big',
        'clear',
        'cliffs',
        'cold',
        'grassy',
        'good fishing',
        'islands and bays',
        'large',
        'narrow',
        'remote',
        'scentic',
        'shallow',
        'small',
        'warm',
        'windy',
      ],
      fishing: ['bass', 'pike', 'trout', 'walleye'],
    },
    rels: ['toponym', 'waterbody'],
    subtypes: {
      bay: {
        name: 'Bay',
      },
      bog: {
        name: 'Bog',
        icon_url: '/images/map-wetlands.png',
        mapicon_url: '/images/map-wetlands-simple.png',
      },
      canal: {
        name: 'Canal',
      },
      creek: {
        name: 'Creek',
      },
      harbour: {
        name: 'Harbour',
      },
      inlet: {
        name: 'Inlet',
      },
      lake: {
        name: 'Lake',
      },
      marsh: {
        name: 'Marsh',
        icon_url: '/images/map-wetlands.png',
        mapicon_url: '/images/map-wetlands-simple.png',
      },
      pond: {
        name: 'Pond',
      },
      river: {
        name: 'River',
      },
      spring: {
        name: 'Spring',
        zoom: 12,
        icon_url: '/images/map-waterdrop.png',
        mapicon_url: '/images/map-waterdrop-simple.png',
        attributes: {
          features: ['water tank'],
        },
      },
      swamp: {
        name: 'Swamp',
        icon_url: '/images/map-wetlands.png',
        mapicon_url: '/images/map-wetlands-simple.png',
      },
      wetlands: {
        name: 'Wetlands',
        icon_url: '/images/map-wetlands.png',
        mapicon_url: '/images/map-wetlands-simple.png',
      },
    },
  },

  // waterbody
  waterbody_feature: {
    name: 'Waterbody',
    zoom: 14,
    icon_url: '/images/map-ford.png',
    mapicon_url: '/images/map-ford-simple.png',
    attributes: {
      features: [],
    },
    rels: ['waterbody'],
    subtypes: {
      beaver_dam: {
        name: 'Beaver Dam',
      },
      liftover: {
        name: 'Liftover',
      },
      rapids: {
        name: 'Rapids',
      },
      shallow_riffle: {
        name: 'Shallow Riffle',
      },
      waterfall: {
        name: 'Waterfall',
        icon_url: '/images/map-waterfall.png',
        mapicon_url: '/images/map-waterfall-simple.png',
      },
    },
  },

  // wateraccess
  wateraccess: {
    name: 'Access Point',
    zoom: 10,
    icon_url: '/images/map-kayaking.png',
    mapicon_url: '/images/map-kayaking.png',
    attributes: {
      activities: [
        'backcountry camping',
        'canoeing',
        'boating',
        'kayaking',
        'hiking',
      ],
      features: ['dock', 'ramp', 'canoe put-in', 'parking'],
    },
    rels: ['toponym', 'waterbody'],
    subtypes: [],
  },
};

export { LocationTypeInfoData };
